import * as React from 'react';
import b_ from 'b_';
import translate, { InjectedTranslateProps } from 'shared/utils/translate';
import RiskIcon from 'components/RiskIcon';
import { Stocks_StockRisk } from '../../../../../__generated__/globalTypes';

import './index.scss';

interface Props {
  level: Stocks_StockRisk;
  showIcon?: boolean;
}

const b = b_.with('stock-risk-option');

const RiskOption: React.SFC<Props & InjectedTranslateProps> = ({ t, level, showIcon }) => (
  <span className={b()}>
    <div>{t(level)}</div>
    {showIcon && <RiskIcon shaped level={level} />}
  </span>
);

export default translate(RiskOption);
